
import { defineComponent } from 'vue'
import { formatDate } from '~/utils/date'
import { getDefaultAvatar } from '~/utils/ui'

/**
 * Component that is responsible to render the integration logo and name on detailed view
 */
export default defineComponent({
  name: 'IntegrationInstalledBy',

  props: {
    enabledOn: {
      type: String,
      required: true
    },
    avatar: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },

  methods: {
    getDefaultAvatar,
    formatDate
  }
})
